import { motion, useAnimate, type AnimationSequence } from 'framer-motion'
import { useEffect } from 'react'
import { useTranslate } from '../../../../hooks/language/use-translate'
import { useGlobalStore } from '../../../../store/global-store'
import type { PositionReturnLuck } from '../../../../store/live/live-notify'
import type { NotifyLuckEarned } from '../../../../types/lives/notifies'
import blue from '../assets/blue.png'
import gold from '../assets/gold.png'
import pink from '../assets/pink.png'
import purpleDark from '../assets/purple-dark.png'
import red from '../assets/red.png'

interface Props {
  toast: NotifyLuckEarned
  position: PositionReturnLuck
}

export function Toast({ toast, position }: Props) {
  const remove = useGlobalStore((state) => state.removeNotifyGiftLuck)

  const [scope, animate] = useAnimate()

  const { translate } = useTranslate()

  useEffect(() => {
    const sequence: AnimationSequence = [
      [scope.current, { scale: 1, opacity: 1 }, { duration: 1 }],
      [scope.current, { opacity: 0 }, { duration: 2, delay: 1 }],
    ]

    if (toast) {
      animate(sequence).then(() => remove(toast, position))
    }
  }, [toast, position, scope, animate, remove])

  let imgBackground = blue

  if (toast.returnTimes < 101) {
    imgBackground = blue
  } else if (toast.returnTimes < 251) {
    imgBackground = pink
  } else if (toast.returnTimes < 501) {
    imgBackground = purpleDark
  } else if (toast.returnTimes < 1001) {
    imgBackground = red
  } else {
    imgBackground = gold
  }

  return (
    <motion.div
      ref={scope}
      className="flex flex-col justify-center items-center gap-10 opacity-0 relative"
      style={{ scale: 0.3 }}
    >
      <div
        className="rounded-full w-40 h-40 flex justify-center items-center relative"
        style={{
          backgroundImage: `url(${imgBackground})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain',
        }}
      >
        <div className="flex flex-col absolute items-center justify-center">
          <span className="colored-text text-[10px] bg-clip-text text-gray-900 font-bold mt-4">
            WIN Coins
          </span>

          <span
            className="colored-text text-base bg-clip-text text-transparent font-bold "
            style={{
              backgroundImage: 'linear-gradient(purple, blue)',
            }}
          >
            {toast?.returnValues}
          </span>
        </div>

        <div className="flex flex-col items-center justify-center absolute bottom-5">
          <span className="colored-text text-[10px] bg-clip-text font-bold text-white">
            {translate('return-value-luck-you-won')}
          </span>

          <span
            className="colored-text text-[10px] bg-clip-text text-transparent font-bold leading-none"
            style={{
              backgroundImage: 'linear-gradient(white, white)',
            }}
          >
            {toast.returnTimes}{' '}
            <span className="text-white leading-none">
              {translate('return-value-luck-times-game')}
            </span>
          </span>
        </div>
      </div>
    </motion.div>
  )
}
